import { render, staticRenderFns } from "./CargarPermisoProvisional.vue?vue&type=template&id=ee48d82e&"
import script from "./CargarPermisoProvisional.vue?vue&type=script&lang=js&"
export * from "./CargarPermisoProvisional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports